import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { hideSpinner, showSpinner } from 'src/app/core/services/functions.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/modules/shared/imports/services/common.service';
import { MainService } from '../../services/main.service';



@Component({
    selector: 'app-dialog-modify-seller',
    templateUrl: './dialog-modify-seller.component.html',
    styleUrls: ['./dialog-modify-seller.component.scss'],
    // providers: [
    //   { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    //   { provide: MAT_DATE_FORMATS, useValue: DATE_FORMAT },
    // ],
})
export class DialogModifySellerComponent implements OnInit {
    lengthReferencia: number = 0;
    stores: any
    storesFiltered: any
    state: any = ["A", "I"]
    types_cash: any = ["S", "A", "P"]
    title: string = "Modificar Cajero"
    description: string = "Modifique los datos del cajero"
    showFieldAudit = false;
    showFieldInactive = false;

    form: FormGroup;


    constructor(private mainService: MainService, private commonService: CommonService, private mdDialogRef: MatDialogRef<DialogModifySellerComponent>, private helpers: HelpersService,
        private fb: FormBuilder,
        @Inject(MAT_DIALOG_DATA) data
    ) {
        this.form = this.fb.group({
            cod: [data["COD"]],
            tienda: [{ "C_AGE": data["C_AGE"], "NOM": data["NOM_AGE"] }],
            cajarap: [data["APL_CAJARAP"]],
            t_cajero: [data["TIPO_CAJERO"]],
            estado: [data["EST"]]

        });
    }

    async ngOnInit(): Promise<void> {
        this.stores = (await this.commonService.findAllStores())['data']
        this.storesFiltered = this.stores
    }

    async close() {
        console.log(this.form)
        this.mdDialogRef.close(null);
    }

    save() {
        let form = this.form.value
        showSpinner()
        this.mainService.update(form.cod, form.tienda["C_AGE"], form.cajarap, form.t_cajero, form.estado).then(e => {
            console.log(e)
            if (e["success"]) {
                this.mdDialogRef.close("save")

            }
            else {
                this.helpers.notifications.errorMessage('No se pudo guardar Cajero')
            }
            hideSpinner()
        })

    }
    storeFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value.toUpperCase();
        console.log(filterValue)
        if (!filterValue) {
            this.storesFiltered = this.stores
            return
        }
        this.storesFiltered = this.stores.filter(store => store.C_AGE.includes(filterValue) || store.NOM.toUpperCase().includes(filterValue))

    }

    displayFn(code: any): string {
        console.log(code)
        return code ? `${code.C_AGE} - ${code.NOM}` : '';
    }


}